import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from '@/app/App';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import { Provider } from 'react-redux';
import { store } from '@/store/Store'
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import { sentryClientOptions, sentryReplayPrivacy } from '@/sentryPrivacy';
import './i18n';
Amplify.configure(awsconfig);

Sentry.init({
  ...sentryClientOptions({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(sentryReplayPrivacy),
    ],
  }),
  tracePropagationTargets: [import.meta.env.VITE_HOST],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
